import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import slugify from 'react-slugify';
import { reportData } from '../../../data/report-data/report-data/reportData';
import NoMatch from '../../no-match/NoMatch';
import Header from '../../../components/layout/header/Header';
import DynamicWordPressHeader from '../../../components/layout/header/DynamicWordPressHeader';
import MainSidebar from '../../../components/layout/sidebar/main-sidebar/MainSidebar';
import ReportsSidebar from '../../../components/layout/sidebar/reports-sidebar/ReportsSidebar';
import WordPressSidebar from '../../../components/layout/sidebar/wordpress-sidebar/WordPressSidebar';
import DynamicReportContentAutoSlug from '../../../components/reports/DynamicReportContentAutoSlug';
import AtaquesDDoSComoMitigarlosPreview from '../report-preview/AtaquesDDoSComoMitigarlosPreview';
import AntiSpoofingPreview from '../report-preview/AntiSpoofingPreview';
import EstudioAtaquesDDoSPreview from '../report-preview/EstudioAtaquesDDoSPreview';
import DNSOpenResolversPreview from '../report-preview/DNSOpenResolversPreview';
import HistoriaDeExitoPreview from '../report-preview/HistoriaDeExitoPreview';
/* import InvestigacionSobreAtaquesDdos from '../reports/investigacion-sobre-ataques-ddos/InvestigacionSobreAtaquesDdos';
 */
/* import AntiSpoofing from '../reports/estudio-antispoofing/AntiSpoofing'; */
import VulnerabilidadAtaquesDdosMaster from '../reports/vulnerabilidad-ataques-ddos/VulnerabilidadAtaquesDdosMaster';
import GenericWordPressReport from '../../interconnection/reports/evolucion-global-y-regional-de-la-adopcion-de-rpki/GenericWordPressReport';
import { MenuContext, MobileContext } from '../../../context/DataContext';
import Footer from '../../../components/layout/footer/Footer';
import UseLang from '../../../hooks/UseLang';
import InvestigacionAtaquesDdosPreview from '../report-preview/InvestigacionAtaquesDdosPreview';


// Objeto que mapea los componentes con sus identificadores
const reportComponents = {
    /* investigacionAtaquesDdos: InvestigacionSobreAtaquesDdos, */
    antiSpoofing: GenericWordPressReport,
    ataquesDdosComoMitigarlos: AtaquesDDoSComoMitigarlosPreview,
    unaHistoriaDeExitoEnCiberseguridad: HistoriaDeExitoPreview,
    vulnerabilidadAtaquesDdos: VulnerabilidadAtaquesDdosMaster,
    dnsOpenResolversIPv4Data: DNSOpenResolversPreview,
    rfc8950: GenericWordPressReport, // Componente genérico de WordPress
    sobreAtaquesDdosInvestigacion: GenericWordPressReport
    // Agregar más reportes aquí
};

function HomeCybersecurity({ lang, routes, myRoutes }) {
    const { isMobile } = useContext(MobileContext)
    const { isIndice, openIndice } = useContext(MenuContext)
    
    // Función para detectar si un componente es de WordPress
    const isWordPressComponent = (reportId) => {
        // Lista de componentes que usan WordPress
        const wordpressComponents = ['rfc8950', 'sobreAtaquesDdosInvestigacion', 'antiSpoofing'];
        return wordpressComponents.includes(reportId);
    };
    
    // Función para obtener el slug de WordPress basado en el reportId
    const getWordPressSlug = (reportId) => {
        const slugMap = {
            'rfc8950': 'implementacion-del-rfc8950-para-la-transicion-a-ipv6-only-soporte-de-ipv4aas-en-redes-mikrotik',
            'sobreAtaquesDdosInvestigacion': 'investigacion-sobre-ataques-ddos',
            'antiSpoofing': 'estudio-anti-spoofing-en-la-region#resumen-ejecutivo'
        };
        return slugMap[reportId];
    };

    // Generar rutas dinámicamente desde reportData
    const generateRoutes = () => {
        const routes = [];
        
        // Primero agregar rutas específicas de WordPress con slugs conocidos
        Object.entries(reportData).forEach(([reportId, reportContent]) => {
            const Component = reportComponents[reportId];
            if (!Component) return;

            const isWordPress = isWordPressComponent(reportId);
            const wpSlug = isWordPress ? getWordPressSlug(reportId) : null;
            
            // Para componentes de WordPress, usar el slug de WordPress directamente
            // Para componentes normales, generar slug desde el título
            const sluggedPath = isWordPress ? wpSlug : slugify(reportContent[lang]?.title || reportContent.es.title);

            routes.push(
                <Route
                    key={reportId}
                    path={sluggedPath}
                    element={<>
                        <Header
                            url_es={`/es/${myRoutes?.es?.ciberseguridad}/${slugify(reportContent?.es?.title)}`}
                            url_en={`/en/${myRoutes?.en?.ciberseguridad}/${slugify(reportContent?.en?.title)}`}
                            url_pt={`/pt/${myRoutes?.pt?.ciberseguridad}/${slugify(reportContent?.pt?.title)}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {/* Sidebar lateral */}
                                    {((!isMobile) || (isMobile && isIndice)) && (
                                        <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                            {isWordPress ? (
                                                <WordPressSidebar
                                                    slug={wpSlug}
                                                />
                                            ) : reportContent?.es?.items ? (
                                                <ReportsSidebar
                                                    menu_lateral={`${slugify(reportContent?.es?.title)}`}
                                                    category={'ciberseguridad'}
                                                    routes={routes}
                                                    lang={lang}
                                                />
                                            ) : (
                                                <MainSidebar
                                                    category='ciberseguridad'
                                                    lang={lang}
                                                    routes={routes}
                                                />
                                            )}
                                        </aside>
                                    )}
                                    
                                    {/* Contenido principal */}
                                    <main className="report_content_wrapper">
                                        <section>
                                            {isWordPress ? (
                                                <Component
                                                    displayMode="full"
                                                    lang={lang}
                                                    reportId={reportId}
                                                />
                                            ) : (
                                                <Component
                                                    displayMode="full"
                                                    lang={lang}
                                                />
                                            )}
                                        </section>
                                    </main>
                                </div>
                            </div>
                        </div>
                        {isMobile &&
                            <div className="report_button_menu" onClick={openIndice}>
                                <div>
                                    {!isIndice && <i className="fas fa-list"></i>}
                                    {isIndice && <i className="fas fa-times"></i>}
                                </div>
                            </div>
                        }
                        <Footer {...footerProps} />
                    </>
                    }
                />
            );
        });

        // Agregar ruta catch-all para WordPress que acepte cualquier slug
        routes.push(
            <Route
                key="wordpress-catch-all"
                path=":anySlug"
                element={<>
                    <DynamicWordPressHeader 
                        myRoutes={myRoutes}
                        category="ciberseguridad"
                    />
                    <div className="report_work_table">
                        <div className="report_main_wrapper">
                            <div>
                                {/* Sidebar lateral */}
                                {((!isMobile) || (isMobile && isIndice)) && (
                                    <aside className={`lateral_menu_wrapper ${isMobile ? 'mobile_lateral_menu' : ''}`}>
                                        <WordPressSidebar
                                            slug={null} // Se detectará automáticamente
                                        />
                                    </aside>
                                )}
                                
                                {/* Contenido principal - usa DynamicReportContentAutoSlug para detectar el slug automáticamente */}
                                <main className="report_content_wrapper">
                                    <section>
                                        <DynamicReportContentAutoSlug />
                                    </section>
                                </main>
                            </div>
                        </div>
                    </div>
                    {isMobile &&
                        <div className="report_button_menu" onClick={openIndice}>
                            <div>
                                {!isIndice && <i className="fas fa-list"></i>}
                                {isIndice && <i className="fas fa-times"></i>}
                            </div>
                        </div>
                    }
                    <Footer {...footerProps} />
                </>
                }
            />
        );

        return routes;
    };

    // Defino props con className para agregar al elemento Footer
    const footerProps = {
        className: `master_foot_reports ${!isMobile ? 'foot_report' : 'basic_foot'}`,
        ...((!isMobile) && { footer: 'reports' })
    };

    const createHome = () => {
        return (
            <Route
                index
                element={
                    <>
                        <Header
                            url_es={`/es/${myRoutes?.es?.ciberseguridad}`}
                            url_en={`/en/${myRoutes?.en?.ciberseguridad}`}
                            url_pt={`/pt/${myRoutes?.pt?.ciberseguridad}`}
                        />
                        <div className="report_work_table">
                            <div className="report_main_wrapper">
                                <div>
                                    {!isMobile && (
                                        <aside className="lateral_menu_wrapper">
                                            <MainSidebar category='ciberseguridad' lang={lang} routes={routes} />
                                        </aside>
                                    )}
                                    <main className="report_content_wrapper">
                                        <section>
                                            <div className="report_list report_preview">
                                                <UseLang es>Informes técnicos, Ciberseguridad </UseLang>
                                                <UseLang en>Technical Reports, Cibersecurity</UseLang>
                                                <UseLang pt>Relatórios técnicos, Cibersegurança </UseLang>
                                                 
                                                <InvestigacionAtaquesDdosPreview />
                                                <AtaquesDDoSComoMitigarlosPreview />
                                                <AntiSpoofingPreview />
                                                <EstudioAtaquesDDoSPreview />
                                                <DNSOpenResolversPreview />
                                                <HistoriaDeExitoPreview />
                                            </div>
                                        </section>
                                    </main>
                                </div>
                            </div>
                        </div>
                        <Footer
                            footer='reports'
                            className="master_foot_reports foot_report"
                        />
                    </>
                }
            />
        );
    };
    return (
        <Routes>
            {/* Ruta absoluta en "/es/ciberseguridad" */}
            {createHome()}
            {/* Rutas para reportes de ciberseguridad "/es/ciberseguridad/reportContent?.es?.title"  */}
            {generateRoutes()}
            {/* Rutas que no coinciden Ejemplo: "/es/ciberseguridad/example" */}
            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
}

export default HomeCybersecurity;